import type { ElementType, ReactNode } from 'react';

interface ContainerProps {
  as?: ElementType;
  className?: string;
  children: ReactNode;
}

// Canonical page-width wrapper. Use everywhere content needs the standard
// gutter — do NOT hand-write `max-w-7xl mx-auto px-4 md:px-8`.
export default function Container({ as: Tag = 'div', className = '', children }: ContainerProps) {
  return <Tag className={`mx-auto w-full max-w-7xl px-4 md:px-8 ${className}`}>{children}</Tag>;
}
